import SortableTable, { SortableTableProps } from "components/SortableTable";
import CardCollapsible from "ds/components/Card/Collapsible";
import Counter from "ds/components/Counter";
import { useToggle } from "hooks/useToggle";

import styles from "./styles.module.css";

type CollapsibleTableProps<T> = Omit<SortableTableProps<T>, "ariaLabel"> & {
  title: string;
};

const CollapsibleTable = <T,>({ title, ...rest }: CollapsibleTableProps<T>) => {
  const [isCollapsed, toggle] = useToggle(false);

  return (
    <CardCollapsible
      ariaLevel={4}
      ariaLabel={title}
      title={title}
      isCollapsed={isCollapsed}
      onToggle={toggle}
      titleSuffix={<Counter count={rest.items.length} />}
      fullbleed
    >
      <div className={styles.wrapper}>
        <SortableTable ariaLabel={title} {...rest} />
      </div>
    </CardCollapsible>
  );
};

export default CollapsibleTable;
